<script>
    import { createEventDispatcher } from 'svelte';

    export let icon = "dollar sign"
    export let color = "red"
    export let fg = null
    export let shadow = false;

    const dispatch = createEventDispatcher();
</script>

<button 
    class="huge circular ui green icon button shadow" 
    style="background-color: {color} !important;{fg ? "color: " + fg + ";" : ""}"
    on:click={() => dispatch('click')}
>
    <i class="icon {icon}"/>
</button>

<style>
    .shadow {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
</style>
